import React, { useState } from "react";
import "./Testimonials.css";
import { testimonialsData } from "../../data/testimonialsData/TestimonialData";
import changeimgp from "../../images/download (15).png";
import leftchange from "../../images/download s(15).png";
import { motion } from "framer-motion";
export default function Testimonials() {
  const transition = { type: "spring", duration: 3 };
  const [select, setselect] = useState(0);
  const tLenght = testimonialsData.length;
  return (
    <div className="testimonials" id="testimonials">
      <div className="left-t">
        <span>Testimonials</span>
        <span className="stroke-text">What they</span>
        <span>say about us</span>
        <motion.span
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={transition}
          key={select}
        >
          {testimonialsData[select].review}
        </motion.span>
        <span>
          <span>{testimonialsData[select].name}</span>-{" "}
          {testimonialsData[select].status}
        </span>
      </div>
      <div className="right-t">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          transition={{ ...transition, duration: 2 }}
          whileInView={{ opacity: 1, x: 0 }}
        ></motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          transition={{ ...transition, duration: 2 }}
          whileInView={{ opacity: 1, x: 0 }}
        ></motion.div>
        <motion.img
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={transition}
          key={select}
          src={testimonialsData[select].image}
          alt="image1"
        />

        <div className="arrows">
          <img
            src={leftchange}
            alt="leftchange"
            onClick={() => {
              select === 0
                ? setselect(tLenght - 1)
                : setselect((prev) => prev - 1);
            }}
          />
          <img
            src={changeimgp}
            alt="changeimg"
            onClick={() => {
              select === tLenght - 1
                ? setselect(0)
                : setselect((prev) => prev + 1);
            }}
          />
        </div>
      </div>
    </div>
  );
}
